import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a05f96c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-me" }
const _hoisted_2 = {
  class: "knowledge",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("ins", null, "Knowledge")
], -1))
const _hoisted_4 = {
  class: "my-work",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("ins", null, "My Work")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyWork = _resolveComponent("MyWork")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowledgeArray, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            "data-aos": "fade-left",
            "data-aos-easing": "ease"
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myWorkArray, (work, index) => {
        return (_openBlock(), _createBlock(_component_MyWork, {
          icon: work.icon,
          link: work.link,
          details: work.details,
          name: work.name,
          technology: work.technology,
          key: index
        }, null, 8, ["icon", "link", "details", "name", "technology"]))
      }), 128))
    ])
  ]))
}